<template>
  <div >
    <!--Title/Actions-->
    <div class="page-header bg-white border-bottom">
      <div class="container d-flex justify-content-between">
        <h3><i class="fas fa-info-circle"></i>&nbsp;Company Profile</h3>
        <div>
          <a @click="saveCompanyLocal" class="btn btn-primary text-white">Save</a>
        </div>
      </div>
    </div>
    <div class="container mb-5 mt-3">
      <div class="row justify-content-center">

        <!--Links-->
        <div v-show="false" class="col-md-4 col-12">
          <b-card class="bg-primary py-5 fluid">
            <b-card-text>
              <img class="d-block m-auto" src="../assets/images/logo-blue-ridge.png"/>
            </b-card-text>
          </b-card>
        </div>

        <!--Main View-->
        <div class="col pl-3 mt-md-0 mt-3" v-if="currentCompany.id">
          <div class="form-container p-md-4 p-3">
            <b-form-group label="Type">
              <b-form-select
                placeholder="Company Type"
                selection
                :options="companyTypeOptions"
                v-model="currentCompany.type"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group label="Company Name">
              <b-form-input placeholder="Company Name" v-model="currentCompany.name"></b-form-input>
            </b-form-group>
            <b-form-group label="">
              <b-form-checkbox v-model="currentCompany.trackEventManagementReportChanges">Audit Event Manager Report</b-form-checkbox>
            </b-form-group>
            <address-form
              ref="addressForm"
              v-model="currentCompany.address"
              :state-options="stateOptions"
              :country-options="countryOptions"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AddressForm from '../components/shared/AddressForm.vue'

export default {
  name: 'CompanyProfile',
  components: { AddressForm },
  created () {
    this.loadCompany()
    this.getLookupStates()
    this.getLookupCountries()
  },
  data () {
    return {
      currentCompany: {},
      companyTypeOptions: [
        {
          text: 'Property Management',
          value: 1
        },
        {
          text: 'Other',
          value: 99
        }
      ]
    }
  },
  computed: {
    stateOptions () {
      return (this.$store.state.lookups.states || []).map(s => ({
        value: s.abbreviation,
        text: s.name,
        country: s.country
      }))
    },
    countryOptions () {
      return this.$store.state.lookups.countries || []
    }
  },
  methods: {
    ...mapActions('company', ['saveCompany', 'getCompanyForEdit']),
    ...mapActions('lookups', ['getLookupStates', 'getLookupCountries']),
    async loadCompany () {
      var result = await this.getCompanyForEdit()
      this.currentCompany = result.data
      if (!this.currentCompany.address) {
        this.currentCompany.address = {}
      }
    },
    async saveCompanyLocal (data) {
      if (this.$refs.addressForm && !this.$refs.addressForm.validate()) {
        return
      }
      this.saveCompany(this.currentCompany)
        .then(result => {
          this.$store.commit('updateCompanyName', {
            companyId: this.$store.state.userCurrentCompany.companyId,
            companyName: this.currentCompany.name
          })
          this.$toasted.show('Company Saved.', {duration: 4000})
        })
    }
  }
}
</script>

<style>
  .company-name{
    background-color: transparent !important;
    border: none !important;
    font-size: 150% !important;
    color: #fff !important;
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Company.vue